<div class="modal-header">
    <h4 class="modal-title">Änderungen Speichern?</h4>
  </div>
  <div class="modal-footer">
  <button type="submit" class="btn btn-success round" (click)="onSubmit()">Ja</button>
  <button type="reset" class="btn round bg-red" style="color: white;" (click)="activeModal.close('Schließen')">Nein</button>
  </div>
